/**
 * What is left to fill in before a message can go to a customer. A drafted
 * message marks each blank `[placeholder: what to fill in]`, and one that still
 * has a blank is never sent (SA-D21): a composer that speaks to a customer
 * stops the send and says what is left, and the platform refuses one that slips
 * through. Which spans are blanks, read through the box's markdown escapes, is
 * `findPlaceholders`'s call (`@birdwatch/common`), the platform's check too.
 */

import { CustomApiError } from "@birdwatch/client";
import { findPlaceholders } from "@birdwatch/common";

/**
 * "Fill in 2 placeholders before sending: two visit times, price" for the box's
 * text, one label per blank in order; null when none is left.
 */
export function placeholdersLeftNote(content: string): string | null {
  const labels = findPlaceholders(content);
  if (labels.length === 0) return null;
  const count =
    labels.length === 1 ? "1 placeholder" : `${labels.length} placeholders`;
  return `Fill in ${count} before sending: ${labels.join(", ")}`;
}

/**
 * The platform's reason when it refused a message that still has a placeholder
 * (422 `PLACEHOLDERS_LEFT`): it names each blank. Undefined for any other failure.
 */
export function placeholdersLeftReason(error: unknown): string | undefined {
  return error instanceof CustomApiError && error.code === "PLACEHOLDERS_LEFT"
    ? error.message
    : undefined;
}
